import React from 'react'

const Location = () => {
  return (
    <div>
    <a style={{textDecoration:"none"}} href="https://www.google.com/maps/place/Suti+Khola/@28.5935687,84.1389274,11z/data=!4m10!1m2!2m1!1snilganga+hydropower+company!3m6!1s0x39bfd7007665fb7f:0x432a68bc8d366be8!8m2!3d28.5935687!4d84.4190788!15sChtuaWxnYW5nYSBoeWRyb3Bvd2VyIGNvbXBhbnmSARloeWRyb2VsZWN0cmljX3Bvd2VyX3BsYW504AEA!16s%2Fg%2F11vt83xrj9?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D">Location of Company project </a>        

    </div>
  )
}

export default Location;
